
const GET_DIGI_REG_LINKS = 'GET_DIGI_REG_LINKS';
const GET_COMPETITIONS = 'GET_COMPETITIONS';
const GET_COMPETITIONENTRIES = 'GET_COMPETITIONENTRIES';
const GET_DIGI_REGMAN_INFO = 'GET_DIGI_REGMAN_INFO';
const ADD_COMPETITOR = 'ADD_COMPETITOR';
const SET_START = 'SET_START';
const CLEAR = 'CLEAR';
const SET_LINK = 'SET_LINK';
const SET_COMPETITIONS = 'SET_COMPETITIONS';
const SET_ENTRIES = 'SET_ENTRIES';
const REMOVE_COMPETITOR = 'REMOVE_COMPETITOR';

export default {
	GET_DIGI_REG_LINKS,
	GET_COMPETITIONS,
	GET_COMPETITIONENTRIES,
	GET_DIGI_REGMAN_INFO,
	ADD_COMPETITOR,
	SET_START,
	CLEAR,
	SET_LINK,
	SET_COMPETITIONS,
	SET_ENTRIES,
	REMOVE_COMPETITOR,
};
